import { forwardRef } from "react";
import { mergeProps } from "../../shared";
import { useStyleProps, useStyledSystem } from "../../styling"; // Adding the "as" prop to the HTML element components is not an ideal solution but a necessary one for now until we completly remove "as" support from Orbit.
// We must do this, because a component like Button which support the "as" prop also need to use the HtmlButton component as a base element to benefit from our CSS normalizing.

import { jsx as _jsx } from "react/jsx-runtime";
// Not using Box otherwise it adds too many layers of components since these HTML elements components are also used in Orbit own components.
export function htmlElement(name, elementType, className) {
  return /*#__PURE__*/forwardRef((props, ref) => {
    const [styleProps] = useStyleProps(name);
    const mergedProps = mergeProps(styleProps, props);
    const {
      as = elementType,
      children,
      ...rest
    } = useStyledSystem(mergedProps);
    const As = as;
    return /*#__PURE__*/_jsx(As, { ...mergeProps(rest, {
        className,
        ref
      }),
      children: children
    });
  });
}